const QUERY_KEYS = {
  BACKGROUNDS: 'BACKGROUNDS',
  CART: 'CART',
  cart: 'CART',
  COUPONS: 'COUPONS',
  EXTRAS: 'EXTRAS',
  holiday: 'HOLIDAY',
  INDIVIDUAL_PRINTS: 'INDIVIDUAL PRINTS',
  numItems: 'NUM_ITEMS',
  OFFER_PAGE: 'OFFER_PAGE',
  OPTIONS: 'OPTIONS',
  ORDER_PACKAGES: 'ORDER_PACKAGES',
  package: 'PACKAGE',
  PRICELIST: 'PRICELIST',
  BUY_ALL_OPTION: 'BUY_ALL_OPTION',
  foregrounds: 'FOREGROUNDS',
  pricelist: 'PRICELIST',
  RETOUCHING: 'RETOUCHING',
  STUDENT: 'STUDENT',
  STUDENT_IMAGES: 'STUDENT_IMAGES',
  POSES: 'POSES',
  pastImages: 'PAST_IMAGES',
  pastImagesQuickOrder: 'PAST_IMAGES_QUICK_ORDER',
  PRINT_TEMPLATES: 'PRINT_TEMPLATES',
};

export default QUERY_KEYS;
